import localStorage from "../vuex/localStorage";
import CONSTANTS from './constants';
import {mockData, settingMenu} from "./menuMockData";
import Constants from "./constants";
import constants from "./constants";


const menu = {
    operations: null,
    reloadMenu: function () {
    },
    route: '',
    curMenu:null,
    menu: [],
    matchForLink(menus, route) {
        if (menus && menus.length) {
            for (let i = 0; i < menus.length; i++) {
                if (route === menus[i].link) {
                    this.operations = menus[i].operations || [];
                    return this.operations;
                }
                if (menus[i].children) {
                    let res = menu.matchForLink(menus[i].children, route);
                    if (res.length) {
                        return res;
                    }
                }
            }
        }
        return [];
    },
    op: function (code) {
        return true;
    },
    pageOpt: function (){
        let path = this.$route.path.split("#")[0].split("?")[0];
        return localStorage.$getLocalStorageByName(CONSTANTS.pageOptStoreKey).path;
    },
    treeMenuSearch(menus, targetList, val) {
        menus.forEach(e => {
            if (e.title.includes(val)) {
                targetList.push(e)
            }
            if (e.children) {
                this.treeMenuSearch(e.children, targetList, val)
            }
        })
        return targetList;
    },
    cacheMenu: async function (vm) {
        const res = await vm.axios.get("basic/queryRoleMenuByLoginUser");
        let opt = {};
        menu.menu = (function mnTrans(m) {
            return m &&  m.map(_m => {
                if(_m.operations && _m.operations.length){
                    let _opt = {};
                    _m.operations.forEach(e => _opt[e.funcCode] = e.funcName);
                    opt[_m.url.split("?")[0].split('#')[0]] = _opt;
                }
                let _mn = {
                    title: _m.menuName,
                    code: _m.menuCode,
                    icon: _m.icon,
                    color: _m.color,
                    link: _m.url,
                    operations: _m.selectOperations
                }
                if (_m.children) {
                    _mn.children = mnTrans(_m.children);
                }
                return _mn;
            });
        })(res.module || []);
        localStorage.$setLocalStorageByName(CONSTANTS.menuStoreKey, menu.menu);
        localStorage.$setLocalStorageByName(CONSTANTS.pageOptStoreKey, opt);
        return res
    },
    getMenu: function (vm) {
        let keepOldMenu = [
            '64e3103de4b0f712d0d508fa',// sit YU444
            '654da0a9e4b0556849e27732',// 浙江凯西国际货运代理（集团）有限公司
            '6552e8ace4b060de237a57a4',// JIANXING INC
            '656f0a09e4b0bc48c4a047ed',// 技术公司
        ].includes(constants.clientLoginUser.companyId);
        if (Constants.clientLoginUser.root) {
            return [...mockData(constants.clientLoginUser.moduleCode,keepOldMenu),settingMenu];
        }else{
            return mockData(constants.clientLoginUser.moduleCode,keepOldMenu);
        }
    }
}
export default menu;



// WEBPACK FOOTER //
// ./src/common/menu.js